import { moneyFormatter } from './moneyFormatter';

export const formataMontante = (value: string) => {
	const numericValue = +value.replace(/\D/g, '');
	if (numericValue === 0) {
		return '';
	}
	return moneyFormatter(numericValue);
};

export const formataPlaca = (value: string) => {
	const cleanInput = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
	let formattedValue = '';

	const letras = cleanInput.slice(0, 3);
	const numeros = cleanInput.slice(3);

	formattedValue = letras;

	if (numeros) {
		formattedValue += '-' + numeros;
	}

	return formattedValue;
};

export const formataTelefone = (value: string) => {
	if (!value) return '';

	value = value.replace(/\D/g, '');
	value = value.replace(/(\d{2})(\d)/, '($1) $2');
	value = value.replace(/(\d)(\d{4})$/, '$1-$2');

	return value;
};

export const formataCep = (value: string) => {
	if (!value) return '';

	value = value.replace(/\D/g, '');
	value = value.replace(/(\d{5})(\d)/, '$1-$2');

	return value;
};

export const formataCpf = (value: string) => {
	if (!value) return '';

	value = value.replace(/\D/g, '');
	value = value.replace(/(\d{3})(\d)/, '$1.$2');
	value = value.replace(/(\d{3})(\d)/, '$1.$2');
	value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

	return value;
};

export const formataCnpj = (value: string) => {
	if (!value) return '';

	value = value.replace(/\D/g, '');
	value = value.replace(/^(\d{2})(\d)/, '$1.$2');
	value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
	value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
	value = value.replace(/(\d{4})(\d)/, '$1-$2');

	if (value.length > 18) {
		value = value.substring(0, 18);
	}

	return value;
};
